import EcoImg from 'eco-design/base/eco-img';
import { SceneEmail } from '@elem/compCommon/SceneEmail';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A1() {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    return (
        <div className={`vanlife-roadtrips-A1 ${css['vanlife-roadtrips-A1']}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1785900140606-5djrn2-compressed-001.webp"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1785900188104-n2u026-compressed-001.webp"
                alt={t('secA_title')}
                aria-label={t('secA_title')}
            />
            <div className="info">
                <p className="title">{t('secA_title')}</p>
                <p className="desc">{t('secA_desc')}</p>
                <SceneEmail theme="white" type="RVING_ROAD_TRIPS" title={t('secA_title')} defaultChecked={false} />
            </div>
        </div>
    );
}
